import React, { useState, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import { components } from 'react-select';

const createOption = (label) => ({
  label,
  value: label.toLowerCase().trim()
});

const CustomInput = (props) => {
  return (
    <components.Input
      {...props}
      autoComplete="off"
      autoCorrect="off"
      spellCheck="false"
      autoCapitalize="none"
      data-lpignore="true"
      onChange={(e) => {
        e.stopPropagation();
        if (props.onChange) props.onChange(e);
      }}
      onInput={(e) => {
        e.stopPropagation();
        if (props.onInput) props.onInput(e);
      }}
    />
  );
};

const customComponents = {
  Input: CustomInput
};

const customStyles = {
  control: (base, state) => ({
    ...base,
    width: '100%',
    minWidth: 0,
    boxSizing: 'border-box',
    borderWidth: '1px',
    borderColor: state.isFocused ? '#198754' : '#ced4da',
    boxShadow: state.isFocused
      ? '0 0 0 0.2rem rgba(25, 135, 84, 0.2)'
      : 'none',
    minHeight: '48px',
    '&:hover': {
      borderColor: '#198754',
    },
  }),

  valueContainer: (base) => ({
    ...base,
    minWidth: 0,
    flex: '1 1 auto',
    overflow: 'hidden',
    flexWrap: 'nowrap',
  }),

  input: (base) => ({
    ...base,
    width: '50%',
    gridTemplateColumns: '0px 1fr'
  }),

  menuPortal: (base) => ({
    ...base,
    zIndex: 10,
  }),

  menu: (base) => ({
    ...base,
    zIndex: 10,
    backgroundColor: '#fff',
    border: '1px solid #ced4da',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
  }),

  menuList: (base) => ({
    ...base,
    backgroundColor: '#fff',
    padding: '4px 0',
    maxHeight: '240px',
    overflowY: 'auto',
  }),

  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected
      ? '#198754'
      : state.isFocused
        ? '#e9f5ee'
        : '#fff',
    color: state.isSelected ? '#fff' : '#212529',
    cursor: 'pointer',
    padding: '10px 12px',
    ':active': {
      backgroundColor: '#d1e7dd',
    },
  }),

  placeholder: (base) => ({
    ...base,
    color: '#6c757d',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
};

export default function CreatableComponent(props) {
  const { defaultOptions, updateVal, placeholder } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(defaultOptions || []);
  const [value, setValue] = useState(null);

  useEffect(() => {
    if (defaultOptions) {
      setOptions(defaultOptions);
    }
  }, [defaultOptions]);

  const handleCreate = (inputValue) => {
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setIsLoading(false);
      setOptions((prev) => [...prev, newOption]);
      setValue(newOption);
      if (newOption.value) updateVal(newOption.value);
    }, 1000);
  };

  return (
    <CreatableSelect
      isClearable
      components={customComponents}
      placeholder={placeholder}
      isDisabled={isLoading}
      isLoading={isLoading}
      onChange={(newValue) => {
        setValue(newValue);
        updateVal(newValue?.value ?? null);
      }}
      onCreateOption={handleCreate}
      options={options}
      value={value}
      styles={customStyles}
      menuPosition="fixed"
      menuPortalTarget={
        typeof document !== 'undefined' ? document.body : null
      }
      menuShouldScrollIntoView
      maxMenuHeight={240}
    />
  );
}